// 演示站点固定“今天”，用于日期排序与筛选的逻辑一致性
export const SITE_NOW = new Date("2026-10-16T23:59:59");

export function formatViews(views: number): string {
  if (views >= 10000) {
    return `${(views / 10000).toFixed(1)} 万`;
  }
  return `${views}`;
}

export function formatDate(dateStr: string): string {
  const date = new Date(dateStr);
  if (Number.isNaN(date.getTime())) return dateStr;
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(
    date.getDate(),
  ).padStart(2, "0")}`;
}

export function daysAgo(dateStr: string): number {
  const date = new Date(`${dateStr}T00:00:00`);
  if (Number.isNaN(date.getTime())) return Number.POSITIVE_INFINITY;
  const diff = SITE_NOW.getTime() - date.getTime();
  return Math.floor(diff / (24 * 60 * 60 * 1000));
}

export function relativeDate(dateStr: string): string {
  const diffDays = daysAgo(dateStr);
  if (!Number.isFinite(diffDays)) return dateStr;
  if (diffDays <= 0) return "今天";
  if (diffDays === 1) return "昨天";
  if (diffDays < 7) return `${diffDays} 天前`;
  return formatDate(dateStr);
}